// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__16c9g","title":"FrontImage_title__2C_rC"};